<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ profile.name }}</p>
      <small>{{ profile.level ? profile.level.name : "ZAX" }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          key="profileImg"
          :src="
            profile.file
              ? profile.file.includes('http')
                ? profile.file
                : `${url.baseFl}/${profile.file}`
              : emptyProfile
          "
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/profile').catch(() => {})">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>

          
          <vs-divider class="m-1" /> -->

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import emptyProfile from "@/assets/images/elements/empty-profile.jpg";
import url from "@/url.js";

export default {
  data() {
    return {
      emptyProfile,
      url,
      profile: {},
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    logout() {
      this.$vs.loading();
      this.$store.dispatch("auth/logout").then(() => {
        this.$vs.loading.close();
        this.$router.push("/pages/login");
      });
    },
  },
  mounted() {
    if (this.$store.state.auth.profileAccess !== null) {
      this.profile = this.$store.state.auth.profileAccess.profile;
    }
  },
};
</script>
